<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.moveId ? (isEdit ? '编辑移库单' : '查看移库单') : '新增移库单'"
    v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-if="baseForm.moveId && baseForm.moveStatus === '0'">
      <el-button v-if="mixinHasPermi(['inventory:move:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child">
      <item-box class="base-info">
        <template v-slot:title>移库单基本信息</template>
        <template v-slot:content>
          <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
            :disabled="!!(!isEdit && baseForm.moveId)" label-width="120px">
            <el-form-item v-if="baseForm.moveId" class="half" label="移库单号" prop="moveNo">
              <el-input disabled v-model.trim="dialogForm.moveNo" clearable placeholder="请输入移库单号">
              </el-input>
            </el-form-item>
            <el-form-item class="half" label="移库类型" prop="moveType">
              <el-select-dict dictType="MOVE_TYPE" v-model.trim="dialogForm.moveType" clearable placeholder="请选择移库类型" />
            </el-form-item>
            <el-form-item class="half" label="目标仓库" v-if="!baseForm.moveId || isEdit">
              <el-cascader aria-hidden="false" @change="handleWareHouseChange" :options="wareHouseData" clearable
                :props="defaultProps" v-model="moveWareHouse" :disabled="spuList.length > 0" placeholder="请选择目标仓库">
                <template slot-scope="{ node, data }">
                  <div class="warehouse-item flex-c-b">
                    <span>{{ data.wareHouseName }}</span>
                    <span class="flex-shrink flex-c-s" v-if="node.isLeaf && !data.disabled"> (<el-text-dict dictType="CAPACITY_STATUS"
                        :type="mixinJudgeWareHouseTypeFun(data.capacityStatus)">{{ data.quantity }}/{{ data.maxQuantity
                        }}</el-text-dict>) </span>
                  </div>
                </template>
              </el-cascader>
            </el-form-item>
            <el-form-item v-if="baseForm.moveId" class="half" label="移库状态" prop="moveStatus">
              <el-tag-dict :value="dialogForm.moveStatus" dictType="MOVE_STATUS"></el-tag-dict>
            </el-form-item>
            <el-form-item v-if="baseForm.moveId && !isEdit" class="half" label="移库总数量" prop="outSumNumber">
              <el-input disabled v-model.trim="dialogForm.moveSumNumber" clearable placeholder="请输入移库总数量"></el-input>
            </el-form-item>
            <el-form-item class="all" label="备注" prop="remark">
              <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
                placeholder="请输入备注" />
            </el-form-item>
          </el-form>
        </template>
      </item-box>

      <item-box class="base-info">
        <template v-slot:title>商品明细</template>
        <template v-slot:content>
          <div class="btn-box" v-if="!baseForm.moveId || baseForm.moveStatus === '0'">
            <el-button type="primary" size="mini" :disabled="!!(!isEdit && baseForm.moveId)"
              @click="handleAdd">添加商品</el-button>
            <el-button type="danger" size="mini" v-if="!(!isEdit && baseForm.moveId)" :disabled="spuList.length === 0"
              @click="handleClearAll">清空商品</el-button>
          </div>
          <div class="tips flex-c-s" v-if="notAllowWareHouseNum !== 0">总共<el-text-dict style="padding: 0 6px;"
              type="primary">{{ total }}</el-text-dict>条数据，其中<el-text-dict style="padding: 0 6px;" type="warning">{{
                notAllowWareHouseNum }}</el-text-dict>条无权限查看</div>
          <el-table :data="spuList" :row-class-name="getRowClassName">
            <el-table-column align="left" prop="goodsName" label="商品名称" min-width="128px"
              show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="skuListStr" label="规格" min-width="128px"></el-table-column>
            <el-table-column label="生产日期" prop="manufactureDate" align="center" min-width="108px" />
            <el-table-column label="成本单价(元)" prop="costPrice" align="center" min-width="100px" />
            <el-table-column label="原始仓库" prop="wareHouseName" align="center" min-width="128px">
              <template slot-scope="scope">
                {{ getWareHouseName(scope.row.wareHouseId) }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="spuNumber" label="原始库存" width="100px"></el-table-column>
            <el-table-column align="center" prop="wareHouseId" label="目标仓库" min-width="168px">
              <template slot-scope="scope">
                <el-cascader aria-hidden="false" :options="wareHouseData" :disabled="true"
                  v-if="!!(!isEdit && baseForm.moveId) || unSelectWareHouse" clearable :props="otherDefaultProps"
                  v-model="scope.row.moveWareHouseId" placeholder="请选择目标仓库" />
                <el-cascader aria-hidden="false" :options="getResultWareHouseData(scope.row.wareHouseId)" v-else clearable :props="defaultProps"
                  v-model="scope.row.moveWareHouseId" placeholder="请选择目标仓库">
                  <template slot-scope="{ node, data }">
                    <div class="warehouse-item flex-c-b">
                      <span>{{ data.wareHouseName }}</span>
                      <span class="flex-shrink flex-c-s" v-if="node.isLeaf && !data.disabled"> (<el-text-dict dictType="CAPACITY_STATUS"
                          :type="mixinJudgeWareHouseTypeFun(data.capacityStatus)">{{ data.quantity }}/{{ data.maxQuantity
                          }}</el-text-dict>) </span>
                    </div>
                  </template>
                </el-cascader>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="outNumber" label="移库数量" width="160px">
              <template slot-scope="scope">
                <el-input-number class="number-input" :disabled="!!(!isEdit && baseForm.moveId)"
                  v-model="scope.row.moveNumber" :min="1" :max="scope.row.spuNumber"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" v-if="baseForm.moveStatus !== '2' && !(!isEdit && baseForm.moveId)"
              label="操作" width="100px">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="handleDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </item-box>

    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.moveId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="danger" @click="discardEntry" v-hasPermission="['inventory:move:discard']"
          v-show="baseForm.moveId && !isEdit && baseForm.moveStatus === '0'">作 废</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.moveId || isEdit">保 存</el-button>
        <el-button type="success" @click="printMove"
          v-show="baseForm.moveId && !isEdit && baseForm.moveStatus !== '2'">打印移库单</el-button>
        <el-button type="primary" @click="confirmMove"
          v-show="baseForm.moveId && !isEdit && baseForm.moveStatus === '0'">确认移库</el-button>
      </template>
    </div>
    <select-spu ref="selectSpu" :targetMoveWareHouseId="targetMoveWareHouseId" :wareHouseData="wareHouseData"
      title="选择商品" width="1280px" :modal="false" :visible.sync="showSelectSpu" :selectIdArr="selectIdArr"
      @success="handleSuccess" @close="showSelectSpu = false" :modal-append-to-body="true" :append-to-body="true"
      :close-on-click-modal="false" />

    <move-print v-if="baseForm.moveId && baseForm.moveStatus !== '2'" ref="moveNoRef" :spuList="spuList"
      :moveData="dialogForm" :wareHouseData="wareHouseData"></move-print>
  </el-dialog>
</template>
<script>
import { moveApi } from "@/api"
import SelectSpu from "./select-spu.vue"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
import MovePrint from "./move-print.vue"
export default {
  name: "MoveDialog",
  components: { SelectSpu, MovePrint },
  props: {
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    //移库单数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      notAllowWareHouseNum: 0, // 无权限查看的数据条数
      total: 0, // 该入库单 商品条数
      moveWareHouse: [],
      targetMoveWareHouseId: "",
      unSelectWareHouse: false,
      otherDefaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      defaultProps: {
        checkStrictly: false,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      showSelectSpu: false,
      selectIdArr: [],
      spuList: [],
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        moveType: [
          {
            required: true,
            message: "请选择移库单类型",
            trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    showSelectSpu(val) {
      if (!val) {
        this.$refs.selectSpu.clearSelection()
      }
    },
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
        // 渲染已选择的 商品列表
        this.renderSpuList()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getResultWareHouseData(wareHouseId) {
      return this.markTreeNodes(this.wareHouseData, { matchFn: (item) => { return item.wareHouseId === wareHouseId } })
    },
    markTreeNodes(tree, options = {}) {
      const {
        matchFn = () => false,
        markProp = "disabled",
        markValue = true,
        cloneDeep = true
      } = options

      const processNode = (node) => {
        const newNode = cloneDeep ? JSON.parse(JSON.stringify(node)) : { ...node }

        if (matchFn(newNode)) {
          newNode[markProp] = markValue
        }

        if (newNode.children) {
          newNode.children = newNode.children.map(processNode)
        }

        return newNode
      }

      return tree.map(processNode)
    },
    // 清空所有入库商品
    handleClearAll() {
      const _this = this
      this.$modal.confirm("确认清空所有移库商品吗？", {
        beforeClose: (action, instance, done) => {
          // 关闭前调整遮罩层
          _this.mixinRemoveAndAddMask()
          done()
        }
      }).then(() => {
        _this.spuList = []
      })
    },
    //  入库仓库改变事件  
    handleWareHouseChange(val) {
      this.targetMoveWareHouseId = val[val.length - 1] || ""
      if (this.targetMoveWareHouseId) { // 统一仓库 则底下 仓库不让选择
        this.unSelectWareHouse = true
      } else {
        this.unSelectWareHouse = false
      }
    },
    // 获取仓库名字
    getWareHouseName(val) {
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 作废
    discardEntry() {
      const _this = this
      _this.$modal
        .confirm('是否确认作废移库单号为"' + _this.dialogForm.moveNo + '"的数据项？')
        .then(function() {
          return moveApi.discardMove({ moveId: _this.dialogForm.moveId })
        })
        .then(() => {
          _this.$modal.msgSuccess("移库单作废成功")
          _this.$emit("close")
          _this.$emit("successs")
        }).finally((err) => {
          // 关闭前调整遮罩层
          this.mixinRemoveAndAddMask()
        })
    },
    // 确认移库
    confirmMove() {
      moveApi.confirmMove({ moveId: this.dialogForm.moveId }).then(() => {
        this.$modal.msgSuccess("移库单确认成功")
        this.$emit("close")
        this.$emit("successs")
      })
    },
    // 打印移库单 
    printMove() {
      this.$nextTick(() => {
        this.$refs.moveNoRef && this.$refs.moveNoRef.print()
      })
    },
    // 给表格行添加 类
    getRowClassName({ row, rowIndex }) {
      return row.hasError ? "error" : ""
    },
    // 渲染已选择的 商品列表
    renderSpuList() {
      if (this.baseForm.moveId && this.baseForm.moveStatus === "1") {
        moveApi.getMoveDetail({ moveId: this.baseForm.moveId }).then(data => {
          this.spuList = data.rows || []
          this.total = data.total || 0
          this.notAllowWareHouseNum = data.notAllowWareHouseNum || 0
        })
        return
      }

      const spuIdArr = []
      const spuList = []
      const list = this.baseForm.spuListJson ? JSON.parse(this.baseForm.spuListJson) : []
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        const wareHouseId = (Array.isArray(item.wareHouseId) ? item.wareHouseId[item.wareHouseId.length - 1] : item.wareHouseId) || null
        const moveWareHouseId = (Array.isArray(item.moveWareHouseId) ? item.moveWareHouseId[item.moveWareHouseId.length - 1] : item.moveWareHouseId) || null
        if (!this.mixinPermiWareHouseIds.includes(wareHouseId) || !this.mixinPermiWareHouseIds.includes(moveWareHouseId)) {
          spuList.push({ ...item, hasError: true })
        } else {
          spuList.push({ ...item, hasError: false })
        }
        spuIdArr.push(item.wareHouseSpuId)
      }

      this.spuList = spuList
      // 去重一下
      this.selectIdArr = [... new Set(spuIdArr)]
    },
    // 删除
    handleDelete(index) {
      this.spuList.splice(index, 1)
    },
    // 点击新增
    handleAdd() {
      const selectIdArr = this.spuList.map(item => { return item.wareHouseSpuId })
      // 去重
      this.selectIdArr = [...new Set(selectIdArr)]
      this.showSelectSpu = true
    },
    // 选择好添加的单品
    handleSuccess(spuList) {
      this.showSelectSpu = false

      const list = []
      for (let i = 0; i < spuList.length; i++) {
        const item = spuList[i]
        // 旧的列表中是否存在
        const oldItem = this.spuList.find(childItem => { return childItem.wareHouseSpuId === item.wareHouseSpuId })
        if (oldItem) {
          list.push(oldItem)
        } else {
          list.push({
            ...item,
            moveWareHouseId: this.targetMoveWareHouseId, // 要移动的仓库
            moveNumber: 1
          })
        }
      }
      this.spuList = list
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
      // 渲染已选择的 商品列表
      this.renderSpuList()
    },
    // 重置表单
    resetForm() {
      this.unSelectWareHouse = false
      this.moveWareHouse = [] // 入库仓库
      this.targetMoveWareHouseId = ""

      this.notAllowWareHouseNum = 0 // 无权限查看的数据条数
      this.total = 0 // 该入库单 商品条数

      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate((valid) => {
        if (valid) {
          if (this.spuList.length === 0) {
            this.$modal.msgError("请选择移库商品")
            return
          }

          // 判断商品库存id是否存在 且出库数量小于库存数量
          for (let i = 0; i < this.spuList.length; i++) {
            const item = this.spuList[i]
            const moveWareHouseId = Array.isArray(item.moveWareHouseId) ? item.moveWareHouseId[item.moveWareHouseId.length - 1] : item.moveWareHouseId
            if (item.wareHouseId === moveWareHouseId) {
              // 抛异常 跑中间件错误的逻辑
              this.$modal.msgError(`商品名称为【${item.goodsName}】规格为【${item.skuListStr}】的单品存储仓库未修改，请调整移入仓库！`)
              return
            }
            if (item.spuNumber < item.moveNumber) {
              // 抛异常 跑中间件错误的逻辑
              this.$modal.msgError(`商品名称为【${item.goodsName}】规格为【${item.skuListStr}】的单品库存不足，请删除该商品重新添加，并调整移库数量！`)
              return
            }
          }

          this.dialogForm.spuList = this.spuList
          //更新
          if (this.dialogForm.moveId) {
            moveApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑移库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          } else {
            //新增
            moveApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增移库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .item-box {
  .item-content-box {
    .el-table {
      .el-table__row {
        &.error {
          position: relative;

          &::after {
            content: "";
            pointer-events: none;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            position: absolute;
            top: 1px;
            left: 1px;
            border: 1px solid red;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

.el-dialog__body {
  .date-input {
    width: 160px;
  }

  .number-input {
    width: 136px;
  }
}
</style>